// filepath: apps/web/src/features/directory/admin/DirectoryAdminPage.tsx
//
// FR-UI-DIR-1 AC-9 — directory admin actions surface.
//
// The route is mounted at /directory/admin (NOT /admin, which is the
// operator surface and serves a different audience -- see
// apps/web/src/App.tsx `AuthStateRouter`). Role gating is done by the
// AuthStateRouter via the existing admin-access pattern; this page
// assumes the user has directory admin rights and surfaces scoped
// admin actions (e.g., re-index, export, retention control).

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

export function DirectoryAdminPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <section className="directory-admin" data-testid="directory-admin-page">
      <header className="directory-admin__header">
        <h1>{t("directory.admin.title", "Directory administration")}</h1>
      </header>
      <p className="directory-admin__description">
        {t("directory.admin.description")}
      </p>
      <ul
        className="directory-admin__actions"
        data-testid="directory-admin-actions"
      >
        <li data-testid="directory-admin-action-reindex">
          {t("directory.admin.action.reindex")}
        </li>
        <li data-testid="directory-admin-action-export">
          {t("directory.admin.action.export")}
        </li>
        <li data-testid="directory-admin-action-retention">
          {t("directory.admin.action.retention")}
        </li>
      </ul>
    </section>
  );
}
